module.exports = __webpack_public_path__ + "static/media/4.727d8d2d.png";